<template>
	<header id="header" class="navbar-fixed-top navbar-inverse video-menu" role="banner">
    		<div class="container-fluid">
    		<!-- <div class="row"> -->
                 <div class="navbar-header navbar-responsive">
                     <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                            <span class="sr-only">Toggle navigation</span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>
                        <a class="navbar-brand" href="#">
                                <img src="logo2.png" alt="" class="img-responsive">
                        </a>
                 </div><!--Navbar header End-->
                 	<nav class="nav navbar-style collapse navbar-collapse navigation" id="bs-example-navbar-collapse-1" role="navigation">
                        <ul class="nav navbar-nav navbar-right ">
                           	<li class="active"> <a href="index.html" class="page-scroll">Volver </a></li>
                              <li class="">
                                <a style="cursor:pointer;" v-on:click="cerrarSesion">
                                  {{ logout }} 
                                </a>
                              </li>
                             
                            <!--<li><a href="#about" class="page-scroll" >Quienes Somos</a> </li>
                            <li><a href="#service"  class="page-scroll">Consultoría</a> </li>
                            <li><a href="#testimonial" class="page-scroll">Productos </a> </li>
                            <li><a href="#pricing_table" class="page-scroll">Conferencias </a> </li>
                            <li><a href="#blog" class="page-scroll">Consejos</a> </li>
                            <li><a href="videos.html" class="page-scroll">Videos</a> </li>
                            <li><a href="#contact" class="page-scroll">Contactanos</a> </li>-->
                        </ul>
                     </nav>
                </div><!-- /.container-fluid -->
		</header>
</template>
<script>
	export default{
		data(){
			return{
        logout: 'Logout'
			}
		},
    methods:{
      cerrarSesion : function(){
        this.$emit('key',false);
      }
    }
	}
</script>


// WEBPACK FOOTER //
// src/NavManuDosComponent.vue